import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const prescriptionListApi = async (data) => {
  const endPoint = `/admin/prescriptions?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------Prescription-details--------------------------
export const prescriptionDetailsApi = async (id) => {
  const endPoint = `/admin/prescriptions/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// ----add prescription
export const addPrescription = async ({ id, status }) => {
  const endPoint = `/admin/prescriptions/${id}`;

  return await axios.put(endPoint, { status }, setJwtToken());
};

// ----Cancel prescription
export const cancelPrescriptionApi = async ({
  id,
  status,
  rejectionReason,
}) => {
  const endPoint = `/admin/prescriptions/${id}`;

  return await axios.put(
    endPoint,
    { status, rejectionReason: rejectionReason },
    setJwtToken()
  );
};
